module.exports = __webpack_public_path__ + "img/jinshukuai05-430.faf51745.jpg";